@if (step() !== 'thanks') {
  <div class="dialog-container">
    <div class="dialog-header">{{ 'RATING_POP_UP.RATE_EXPERIENCE' | translate }}</div>
    <button mat-icon-button data-fs-element="Feedback-Button-Close-Header" (click)="dialogRef.close()">
      <mat-icon class="white">close</mat-icon>
    </button>
  </div>
}
<div class="dialog-content" [formGroup]="form">
  @if (step() !== 'thanks') {
    <div class="dialog-text">
      <p class="body-large semi-bold">{{ 'RATING_POP_UP.HOW_SATISFIED' | translate }}</p>
      @if (step() !== 'options') {
        <p class="body-large italic light">
          {{ 'RATING_POP_UP.HELP_US_UNDERSTAND' | translate }}
        </p>
      }
    </div>
    <div class="rating flex flex-column flex-center">
      <ui-rating [rating]="rating()" (ratingChange)="onRatingChange($event)"></ui-rating>
      <div class="text-rating flex flex-justify-between">
        <span>{{ 'RATING_POP_UP.VERY_DISSATISFIED' | translate }}</span>
        <span>{{ 'RATING_POP_UP.VERY_SATISFIED' | translate }}</span>
      </div>
    </div>
  }
  @if (step() === 'options') {
    <div class="options">
      <p class="body-large semi-bold pt-2 pb-1">
        {{ currentQuestion() | translate }}
        <span class="light italic">{{ 'RATING_POP_UP.SELECT_ALL' | translate }}</span>
      </p>
      @for (option of currentOptions(); track option) {
        <mat-checkbox
          [checked]="checkedOptions()[option]"
          (change)="onOptionChange(option, $event.checked)"
        >
          {{ option | translate }}
        </mat-checkbox>
      }
      <mat-checkbox [checked]="otherSelected()" (change)="onOtherChange($event)">
        {{ 'RATING_POP_UP.OTHER' | translate }}
      </mat-checkbox>
      @if (otherSelected()) {
        <div class="option-textarea">
          <textarea
            data-fs-element="Feedback-Textarea-Comment"
            [placeholder]="'LESSONS.LESSONCREATEINFO.CONTENTTEXT' | translate"
            formControlName="other"
            matInput
            cdkTextareaAutosize
            cdkAutosizeMinRows="3"
            cdkAutosizeMaxRows="5"
            class="body-large"
            maxlength="1000"
          ></textarea>
        </div>
      }
    </div>
  }
  @if (step() === 'thanks') {
    <div class="thanks flex flex-column flex-center pt-4 pb-4">
      <button mat-icon-button data-fs-element="Feedback-Button-Close-Thanks" (click)="dialogRef.close()">
        <mat-icon class="primary">close</mat-icon>
      </button>
      <img src="/images/thankyou.svg" />
      <p class="body-large semi-bold mt-3 text-thank">
        {{ 'RATING_POP_UP.THANK_YOU' | translate }}
      </p>
    </div>
  }
  @if (step() !== 'thanks') {
    <div class="btn-rating flex flex-column flex-center">
      <button
        data-fs-element="Feedback-Button-Continue"
        mat-flat-button
        (click)="continue()"
        [disabled]="!canContinue()"
      >
        {{ 'RATING_POP_UP.CONTINUE' | translate }}
      </button>
    </div>
  }
</div>
